export default __webpack_public_path__ + "static/kapper-df0c9959cc39ba8ae38fde293759ed22.jpg";